export const getActivityNameAndId = `
query getActivityNameAndId($activityIds: [ID!]) {
  activities(activityIds: $activityIds) {
    id
    displayName
    activityType
    allowPreDated
  }
}
`;

export interface GetActivityNameAndIdType {
  activities: {
    id: string;
    displayName: string;
    activityType: 'custom' | 'system';
    allowPreDated: boolean;
  }[];
}

export function transformActivityNameAndId(data?: GetActivityNameAndIdType) {
  return data?.activities?.map((activity) => ({
    value: activity.id,
    label: activity.displayName,
    activityType: activity.activityType,
    allowPreDated: activity.allowPreDated,
  })).sort((a, b) => {
    if (a.label < b.label) return -1;

    if (a.label > b.label) return 1;

    return 0;
  }) ?? [];
}
